$mol_icon_align_horizontal_left $mol_icon path \M4 22H2V2H4V22M22 7H6V10H22V7M16 14H6V17H16V14Z
